module.exports = __webpack_public_path__ + "static/media/arrowDown.7b13b353.svg";